import { Grid } from '@mui/material';
import React from 'react';
import DuplicateMemberSkeleton from './DuplicateMemberSkeleton';

function DuplicateMemberListSkeleton() {
  return (
    <Grid container spacing={2}>
      {Array.from({ length: 3 }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Grid item md={4} key={i}>
          <DuplicateMemberSkeleton />
        </Grid>
      ))}
    </Grid>
  );
}

export default DuplicateMemberListSkeleton;
